import { render, staticRenderFns } from "./KnowledgePerformanceDialog.vue?vue&type=template&id=d8c95088&scoped=true"
import script from "./KnowledgePerformanceDialog.vue?vue&type=script&lang=js"
export * from "./KnowledgePerformanceDialog.vue?vue&type=script&lang=js"
import style0 from "./KnowledgePerformanceDialog.vue?vue&type=style&index=0&id=d8c95088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c95088",
  null
  
)

export default component.exports